import React, { useState } from "react";
// import { ImageEditor } from "cai-editor";
import { ImageEditor } from "../dist/esm/index"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
    feedbackActions,
    miAuditSearchActions,
    shelfViewFeedbackActions,
} from "../../store/store";
import { ShelfViewSnackbar } from "../../Annotator/components/snackbar";

export default function AnnotationEditor() {
    const { imageEditorConfig } = useSelector((state) => state.miImageStore);

    const [imageData, setImageData] = useState([]);

    console.log("check", imageEditorConfig);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleChangeData = (e) => {
        console.log("updated data", e);
        setImageData(e);
    };

    const handleSave = async () => {
        console.log(imageData, "data");
        let rect_data = [...imageData.data];
        const not_none_ref = new Set(rect_data.filter((data)=>data.ref && data.ref!=="none").map((req_obj)=>req_obj.ref));
        console.log(not_none_ref,"32");
        const filtered_new_rect = rect_data.filter((data)=> !not_none_ref.has(data.id) )
        console.log(filtered_new_rect,"34")

      
        try {
            dispatch(shelfViewFeedbackActions.setLoading(false));
            const res = await axios.post("/miAuditSearch/update_audit_result", {
                result: filtered_new_rect,
                audit_id: imageEditorConfig.imageDetails.imageAudit,
                type: imageEditorConfig.imageDetails.imageType,
            });
            if (res.data) {
                dispatch(miAuditSearchActions.setAuditDetails(res.data));
                console.log(res.data);

                navigate(-1);
                //   dispatch(feedbackActions.setSnackbarOpen(true))
                // dispatch(
                //   feedbackActions.setSnackbarMessage(
                //     'Audit Updated !'
                //   )
                // )
                // dispatch(feedbackActions.setSnackbarMessageSeverity('warning'))
                // setTimeout(() => {
                //   dispatch(feedbackActions.setSnackbarOpen(false));
                // }, 5000);
            }

            dispatch(shelfViewFeedbackActions.setLoading(false));
        } catch (err) {
            console.log(err, "error");
        }
    };

    return (
        <>
            <div>
                <ImageEditor
                    {...imageEditorConfig}
                    onChange={handleChangeData}
                    onSave={handleSave}
                />
            </div>
            <ShelfViewSnackbar />
        </>
    );
}
